import { Icon, Stack, Typography } from "components";

interface ChipProps extends React.PropsWithChildren {
  background?: string;
  color?: string;
  iconEnd?: string;
}

const Chip: React.FC<ChipProps> = ({
  background = "#e3f2fd",
  color = "#1565c0",
  iconEnd,
  children,
}) => (
  <Stack
    gap={0}
    style={{
      background: background,
      height: "24px",
      minWidth: "24px",
      borderRadius: "24px",
      padding: "0 8px",
      placeItems: "center",
      overflow: "hidden",
    }}
  >
    <Typography
      size={-1}
      color={color}
      whiteSpace="pre"
      style={{ overflow: "hidden", textOverflow: "ellipsis" }}
    >
      {children}
    </Typography>
    {iconEnd && (
      <Icon
        color={color}
        size="15px"
        name={iconEnd}
        style={{ marginBottom: "1px" }}
      />
    )}
  </Stack>
);

export { Chip };
